//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { catchError, map, switchMap } from 'rxjs/operators';
import { DecryptAesClientSide } from 'src/app/core/encryption';
import { EncryptionService } from './utelize/general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths, StorageValues } from '../consts';
import { ExceptionsService } from './utelize/general/exceptions-service';
import { FeatureAccessResetService } from './utelize/access/feature-access-reset-service';
import { getMsalConfig } from '../_config/auth-config';
import { HttpClientService } from './utelize/general/http-client-service';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { of, throwError } from 'rxjs';
import { PublicClientApplication } from '@azure/msal-browser';
import { StorageService } from './utelize/general/storage-service';
import { StringResultDTO } from '../interfaces/general/string-result';
import { SystemLockService } from './utelize/system/system-lock/system-lock-service';
import { SystemUserDTO, SystemUserDTO_EmptyObject } from '../models/system/user/system-user.dto';
import { ToastService } from './toast-service';

const httpOptions={ headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

@Injectable({ providedIn: 'root' })

export class AuthenticationService {
  
  constructor(
    private encryptionService        : EncryptionService,
    private exceptionsService        : ExceptionsService,
    private featureAccessResetService: FeatureAccessResetService,
    private httpClientService        : HttpClientService,
    private storageService           : StorageService,
    private systemLockService        : SystemLockService,
    private toastService             : ToastService
  ) { }

  public canEditSystemOwned(systemOwned: boolean | undefined): boolean {
    try {
      return !systemOwned || (this.currentUserObject()?.canBypassSystemOwned ?? false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public currentUser(): any {
    try {
      return DecryptAesClientSide(this.storageService.getItem(StorageValues.encCurrentUser));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public currentUserObject(): SystemUserDTO {
    try {
      //let currentUser=<SystemUserDTO>JSON.parse(this.currentUser());
      return <SystemUserDTO>JSON.parse(this.currentUser());
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return SystemUserDTO_EmptyObject();
    }
  }

  public tempCurrentUser(): any {
    try {
      return DecryptAesClientSide(this.storageService.getItem(StorageValues.encTempCurrentUser));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public tempCurrentUserObject(): SystemUserDTO {
    try {
      return <SystemUserDTO>JSON.parse(this.tempCurrentUser());
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return SystemUserDTO_EmptyObject();
    }
  }

  public login(email: string, password?: string) {
    try {
      if (!password)
        password="!#SSOLOGIN#!";
      
          password   =password.replace(/\s/g, '');
      var credentials=email + String.fromCharCode(31) + password;
      
      return this.encryptionService.encrypt_AesServerSideForWeb(credentials, true)
             .pipe(
               switchMap((encResult: StringResultDTO) => {
                 const encryptedCredentials=encResult.result;
                 
                 return this.httpClientService.post(environment.eSimApi + eSimApiPaths.InviewRegistration, {
                                                      email     : email,
                                                      credential: encryptedCredentials
                                                    },
                                                    httpOptions
                                                   );
               }),
               map((response: any) => {
                 const user=response;

                 return user;
               }),
               catchError((error: any) => {
                 return throwError(() => this.exceptionsService.formatHttpError(error));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public logout() {
    try {
      this.removeAllUserSystemLocks(this.currentUserObject()?.userId ?? -1);
      this.cleanupAfterLogout();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public logoutApi() {
    try {
      if (!this.currentUserObject())
        return of();
      
      var email      =this.currentUserObject().username;
      var sessionID  =this.currentUserObject().sessionId;
      var credentials=email + String.fromCharCode(31) + sessionID;
      
      return this.encryptionService.encrypt_AesServerSideForWeb(credentials, true)
             .pipe(
               switchMap((encResult: StringResultDTO) => {
                 const encryptedCredentials=encResult.result;
  
                 return this.httpClientService.post(environment.eSimApi + eSimApiPaths.InviewRegistration + "/" + eSimApiPaths.InviewRegistrationLogout, {
                                                      email     : email,
                                                      credential: encryptedCredentials
                                                    },
                                                    httpOptions
                                                   );
               }),
               map((response: any) => {
                 const user=response;
                 
                 return user;
               }),
               catchError((error: any) => {
                 return throwError(() => this.exceptionsService.formatHttpError(error));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public cleanupAfterLogout() {
    try {
      this.storageService.clearAll();
      this.toastService.removeAll();
      this.featureAccessResetService.resetAll();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public changePassword(email: string, password: string) {
    try {
          password   =password.replace(/\s/g, '');
      var credentials=email + String.fromCharCode(31) + password;
      
      return this.encryptionService.encrypt_AesServerSideForWeb(credentials, true)
             .pipe(
               switchMap((encResult: StringResultDTO) => {
                 const encryptedCredentials=encResult.result;
                 
                 return this.httpClientService.post(environment.eSimApi + eSimApiPaths.InviewRegistration + "/" + eSimApiPaths.InviewRegistrationChangePassword, {
                                                      email     : email,
                                                      credential: encryptedCredentials
                                                    },
                                                    httpOptions
                                                   );
               }),
               map((response: any) => {
                 const user=response;
                 
                 return user;
               }),
               catchError((error: any) => {
                 return throwError(() => this.exceptionsService.formatHttpError(error));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public resetPassword(email: string) {
    try {
      var password   ="xxxxxxxxxx";
      var credentials=email + String.fromCharCode(31) + password;
      
      return this.encryptionService.encrypt_AesServerSideForWeb(credentials, true)
             .pipe(
               switchMap((encResult: StringResultDTO) => {
                 const encryptedCredentials=encResult.result;
                 
                 return this.httpClientService.post(environment.eSimApi + eSimApiPaths.InviewRegistration + "/" + eSimApiPaths.InviewRegistrationResetPassword, {
                                                      email     : email,
                                                      credential: encryptedCredentials
                                                    },
                                                    httpOptions
                                                   );
               }),
               map((response: any) => {
                 const user=response;
                 
                 return user;
               }),
               catchError((error: any) => {
                 return throwError(() => this.exceptionsService.formatHttpError(error));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  //#region DB.Table.FailurePortalLogin

  public lockUser(username: string, companyID: number) {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(username, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const usernameEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.InviewRegistration + "/" +
                                                               eSimApiPaths.InviewRegistrationLockUser +
                                                               "?usernameEncSS=" + usernameEncSS +
                                                               "&companyID=" + companyID,
                                                               {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public unlockAdmin(username: string) {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(username, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const usernameEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.InviewRegistration + "/" +
                                                               eSimApiPaths.InviewRegistrationUnlockAdmin +
                                                               "?usernameEncSS=" + usernameEncSS,
                                                               {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public unlockUser(username: string) {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(username, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const usernameEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.InviewRegistration + "/" +
                                                               eSimApiPaths.InviewRegistrationUnlockUser +
                                                               "?usernameEncSS=" + usernameEncSS,
                                                               {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public userIsLocked(username: string) {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(username, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const usernameEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.InviewRegistration + "/" +
                                                               eSimApiPaths.InviewRegistrationUserIsLocked +
                                                               "?usernameEncSS=" + usernameEncSS,
                                                               {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  //#endregion

  //#region SSO
  
  public async loginWithTenant(username: string, tenantId?: string, clientId?: string) {
    try {
      const customConfig=getMsalConfig(tenantId, clientId);
      const customMsal  =new PublicClientApplication(customConfig);
      
      await customMsal.initialize();

      //#region CRN_20250519 - User logs out and back in again quickly before Microsoft frees account, so reattach...

      const result=await customMsal.handleRedirectPromise();
      
      if (result) {
        customMsal.setActiveAccount(result.account);
        return;
      }

      //#endregion

      //#region CRN_20250519 - May not be needed because of the logic above, HOWEVER, leave it to mitigate risk
  
      const inProgress=sessionStorage.getItem(StorageValues.msalInteractionStatus)==="interaction_in_progress";

      if (inProgress) {
        console.warn('MSAL login/logout already in progress. Skipping...');
        return;
      }

      //#endregion
      
      sessionStorage.setItem(StorageValues.msCustomTenantLogin, "true");
      
      await customMsal.loginRedirect({
        scopes   : ["user.read"],
        loginHint: username
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async logoutWithTenant(tenantId?: string, clientId?: string) {
    try {
      const customConfig=getMsalConfig(tenantId, clientId);
      const customMsal  =new PublicClientApplication(customConfig);
  
      await customMsal.initialize();

      const account=customMsal.getActiveAccount() ?? customMsal.getAllAccounts()[0];

      if (account) {
        await customMsal.logoutRedirect({
          account,
          postLogoutRedirectUri: environment.sureSimRootUrl
        });
      } else {
        console.warn("No active account found to logout.");
      }
  
      sessionStorage.removeItem(StorageValues.msCustomTenantLogin);
    }
    catch (e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public async handleCustomTenantRedirectLogin(): Promise<void> {
    try {
      if (window.location.hash==="" && sessionStorage.getItem(StorageValues.msalInteractionStatus)) {
        sessionStorage.removeItem(StorageValues.msalInteractionStatus);
      }
        
      const customLogin=sessionStorage.getItem(StorageValues.msCustomTenantLogin)==="true";
        
      if (customLogin) {
        const customConfig=getMsalConfig();
        const customMsal  =new PublicClientApplication(customConfig);
        
        await customMsal.initialize();
        
        const result=await customMsal.handleRedirectPromise();
        
        if (result) {
          customMsal.setActiveAccount(result.account);
        }
        
        sessionStorage.removeItem(StorageValues.msCustomTenantLogin);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregon

  //#region System Locks

  public removeAllUserSystemLocks(curUserID: number) {
    try {
      this.systemLockService.removeAllUserSystemLocks(curUserID)
      .subscribe({
        next: data => {
          this.cleanupAfterLogout();
        },
        error: error => {
          this.cleanupAfterLogout();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.cleanupAfterLogout();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
